module.exports = __webpack_public_path__ + "static/media/discord.00d62c1e.webp";